import React from 'react'
import LawyerEarnings from "./LawyerEarnings";

const LawyerConsultationHistory = () => {
  return (
    <div>
      <LawyerEarnings />
    </div>
  );
};

export default LawyerConsultationHistory